import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#d7izlqlie__clip0_300_14030)",
        children: [_jsx("path", {
          d: "M0 10C0 4.47715 4.47715 0 10 0V0C15.5228 0 20 4.47715 20 10V10C20 15.5228 15.5228 20 10 20V20C4.47715 20 0 15.5228 0 10V10Z",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#b3byyj6ay__clip1_300_14030)",
          children: [_jsx("path", {
            d: "M-6 -1H26V21H-6V-1Z",
            fill: "#E70013"
          }), _jsx("path", {
            d: "M9.99975 15.5001C12.9453 15.5001 15.3331 13.0376 15.3331 10.0001C15.3331 6.9625 12.9453 4.50006 9.99975 4.50006C7.05423 4.50006 4.66641 6.9625 4.66641 10.0001C4.66641 13.0376 7.05423 15.5001 9.99975 15.5001Z",
            fill: "white"
          }), _jsx("path", {
            d: "M10 5.87494C7.792 5.87494 6 7.72294 6 9.99994C6 12.2769 7.792 14.1249 10 14.1249C11.2773 14.1222 12.4747 13.4924 13.2267 12.4309C12.6373 12.9892 11.8667 13.2999 11.0667 13.2999C9.29867 13.2999 7.86667 11.8232 7.86667 9.99994C7.86667 8.17669 9.29867 6.69994 11.0667 6.69994C11.8667 6.70269 12.6373 7.01344 13.2267 7.57169C12.4747 6.50744 11.2773 5.87769 10 5.87494Z",
            fill: "#E70013"
          }), _jsx("path", {
            d: "M8.66641 9.99993L13.0077 8.54519L10.3251 12.3539V7.64594L13.0077 11.4547L8.66641 9.99993Z",
            fill: "#E70013"
          })]
        })]
      }), _jsx("path", {
        d: "M10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "d7izlqlie__clip0_300_14030",
          children: _jsx("path", {
            d: "M0 10C0 4.47715 4.47715 0 10 0V0C15.5228 0 20 4.47715 20 10V10C20 15.5228 15.5228 20 10 20V20C4.47715 20 0 15.5228 0 10V10Z",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "b3byyj6ay__clip1_300_14030",
          children: _jsx("rect", {
            width: "32",
            height: "22",
            fill: "white",
            transform: "translate(-6 -1)"
          })
        })]
      })]
    }))
  });
};
export default Component;
